import { Checkbox, HStack } from "@chakra-ui/react";
import React from "react";
import FormikSelect from "./FormikSelect";
import DateRange from "./DateRange";
import FormikInput from "./FormikInput";

const ParkingSpaceInput = ({
  formik,
  haveSpaceField,
  idField,
  children,
  startDateField,
  endDateField,
  labelText,
  feeField,
  feeLabelText,
  dateLabel,
}) => {
  return (
    <HStack gap={2}>
      <Checkbox
        {...formik.getFieldProps(haveSpaceField)}
        defaultChecked={formik.values[haveSpaceField]}
      />
      <DateRange
        formik={formik}
        field1={startDateField}
        field2={endDateField}
        label={dateLabel}
      />
      <FormikSelect labelText={labelText} formik={formik} field={idField}>
        {children}
      </FormikSelect>
      <FormikInput formik={formik} labelText={feeLabelText} field={feeField} />
    </HStack>
  );
};

export default ParkingSpaceInput;
